var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F4F4F4",
    transform: "translate(-1358.000000, -624.000000) translate(303.000000, 624.000000) translate(1075.000000, 20.000000) scale(-1, 1) translate(-1075.000000, -20.000000) translate(1055.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13.333
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#383838"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.109 6.413c2.333 0 4.224 1.866 4.224 4.167 0 2.302-1.89 4.167-4.223 4.167h-2.377c-.46 0-.833-.374-.833-.834l.006-.104c.052-.411.402-.73.827-.73h2.377c1.4 0 2.534-1.118 2.534-2.499 0-1.38-1.135-2.5-2.535-2.5h-2.376c-.46 0-.833-.373-.833-.833l.006-.105c.052-.41.402-.729.827-.729zm-5.842 0c.425 0 .775.318.827.73l.006.104c0 .46-.373.833-.833.833H5.89c-1.4 0-2.535 1.12-2.535 2.5 0 1.381 1.135 2.5 2.534 2.5h2.377c.425 0 .775.318.827.729l.006.104c0 .46-.373.834-.833.834H5.89c-2.332 0-4.223-1.865-4.223-4.167 0-2.3 1.891-4.166 4.224-4.167h2.376z",
    transform: "translate(-1358.000000, -624.000000) translate(303.000000, 624.000000) translate(1075.000000, 20.000000) scale(-1, 1) translate(-1075.000000, -20.000000) translate(1055.000000, 0.000000) translate(10.000000, 10.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.197 5.131L3.73 14.851c-.325.301-.344.81-.042 1.135l.02.02c.33.33.86.34 1.2.023l10.466-9.72c.325-.301.344-.81.042-1.134l-.02-.022c-.33-.329-.86-.338-1.2-.022z",
    transform: "translate(-1358.000000, -624.000000) translate(303.000000, 624.000000) translate(1075.000000, 20.000000) scale(-1, 1) translate(-1075.000000, -20.000000) translate(1055.000000, 0.000000) translate(10.000000, 10.000000) translate(9.553178, 10.580154) scale(-1, 1) translate(-9.553178, -10.580154)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectButton);
export default __webpack_public_path__ + "static/media/disconnect-button.4d0d590738537ded5c6d1bdd5a895f20.svg";
export { ForwardRef as ReactComponent };